import { Button } from '@strata/react-buttons';
import { TextInputFormik } from '@strata/react-inputs';
import { validationStrings } from '@strata/strata-ui-strings';
import { Form, Formik } from 'formik';
import { useState } from 'react';
import * as Yup from 'yup';

import { List } from 'components/List';
import { CREATE_ROUTE } from 'services/constants';
import { useGet } from 'services/Http';

const columns = ['NPI', 'First Name', 'Last Name', 'Last Update'];

export const PrescriberList = () => {
    const [searchText, setSearchText] = useState();

    const prescribers = useGet(
        searchText ? `/reference/prescribers/search?search_text=${searchText}` : undefined,
    );

    return (
        <div className="sds_list-page">
            <Formik
                initialValues={{
                    searchText: undefined,
                }}
                validationSchema={Yup.object({
                    searchText: Yup.string()
                        .min(5, 'Must be at least 5 characters.')
                        .required(validationStrings.requiredField.errorMessage),
                })}
                onSubmit={(values) => {
                    setSearchText(values.searchText);
                }}
                validateOnMount
            >
                {(formik) => (
                    <Form
                        className="sds_list-page__content--top"
                        style={{ display: 'flex', flexDirection: 'row' }}
                    >
                        <div className="padding__right--medium" style={{ flex: 1 }}>
                            <TextInputFormik
                                id="searchText"
                                label="Search Prescribers"
                                helperText="Search by name or NPI. If searching by NPI, use full 10 characters. Deactivated prescribers may appear in results but cannot be edited until reactivated."
                                required
                            />
                        </div>
                        <Button
                            label="Search"
                            type="submit"
                            className="margin__top--large"
                            disabled={!formik.isValid}
                            intent={Button.Intent.PRIMARY}
                        />
                    </Form>
                )}
            </Formik>
            {searchText && (
                <List
                    pageTitle="Prescribers"
                    columnNames={columns}
                    isLoading={!prescribers}
                    listData={prescribers?.map((p) => [
                        p.prescriber_npi,
                        p.first_name,
                        p.last_name,
                        p.last_update,
                    ])}
                    createPath={`/prescribers/${CREATE_ROUTE}`}
                    editPath="/prescribers"
                    createButtonLabel="Add Prescriber"
                />
            )}
        </div>
    );
};
